import type { UploadedFile } from './Prototype2Context';

interface UploadedDocumentContext {
  filename: string;
}

interface UserArtifactsContext {
  additional_context?: string;
  uploaded_documents?: UploadedDocumentContext[];
}

const buildUserArtifactsContext = (
  uploadedFiles: UploadedFile[],
  contextText: string
): UserArtifactsContext | undefined => {
  const uploadedDocuments = uploadedFiles.map((file) => ({ filename: file.name }));

  const additionalContext = contextText.trim();
  if (!additionalContext && uploadedDocuments.length === 0) return undefined;

  return {
    ...(additionalContext ? { additional_context: additionalContext } : {}),
    ...(uploadedDocuments.length > 0 ? { uploaded_documents: uploadedDocuments } : {}),
  };
};

export { buildUserArtifactsContext };
export type { UserArtifactsContext, UploadedDocumentContext };
